import { createContext, useContext } from 'react';

export const CurrentUserContext = createContext({
  user: null,
  isConnected: false,
  allowedActions: [],
});

export const useCurrentUser = () => useContext(CurrentUserContext);

export const CurrentUserProvider = ({ children, currentUser = null, allowedActions = [] }) => {
  return <CurrentUserContext.Provider value={{ isConnected: !!currentUser, user: currentUser, allowedActions }}>{children}</CurrentUserContext.Provider>;
};
